import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-layout',
  templateUrl: './footer-layout.component.html',
  styleUrls: ['./footer-layout.component.scss']
})
export class FooterLayoutComponent implements OnInit {
  year;
  constructor() { }

  ngOnInit() {
    const year = new Date();
    this.year = year.getFullYear();
  }

}
